<script>
  import { tick } from 'svelte'
  import { onMount } from 'svelte'
  import { createPostRequest } from '../../src/create_request'
  import { focus } from '../../src/utils'
  import { cart } from '../../src/data_storage.js'
  cart.useLocalStorage()
  import { _, locale, locales } from 'svelte-i18n'
  import CryptoPay from './crypto/crypto_pay.svelte'
  import FiatPay from './fiat/fiat_pay.svelte'

  export let shop
  export let order
  export let signedIn
  export let done_handler
  export let done_paying_handler
  export let disable_canceling_order_handler

  let paymentOption = 'crypto'
  let errors = null
  let show = false

  function checkoutSubmit(meta, handler) {
    fetch(createPostRequest('/cart/checkout_submit.json',
                        'POST',
                        JSON.stringify({ slug: shop.slug, order_id: order.id, order: {meta: meta}})))
      .then(response => response.json())
      .then(data => {
        console.log('checkout_submit:' + shop.slug)
        console.log(data)
        if (data.errors) {
          alert(data.errors)
          errors = data.errors
        } else if (data.id) {
          if (handler) {
            handler(data)
          }
        } else {
          errors = ["Something went wrong, try again later."]
        }
      })
      .catch(err => {
        alert('error ' + err)
      })
  }

  onMount(async () => {
    console.log("checkoutSubmit onMount " + order.payment_option)
    paymentOption = order.payment_option
    show = true
  })

  function handle_crypto_payment_done(data) {
    console.log('handle_crypto_payment_done')

    checkoutSubmit(data, done_handler)
  }

  // continue shopping
  function handle_fiat_payment_done(data) {
    console.log('handle_fiat_payment_done')

    if (done_handler) {
      done_handler()
    }
  }

  // pay now button clicked
  function handle_paynow() {
    // disable cancel order button
    if (disable_canceling_order_handler){
      disable_canceling_order_handler()
    }
  }

  // payment completion return url shown successfully
  function handle_done_paying(data) {
    // confirm order
    checkoutSubmit(data, done_paying_handler)
  }
</script>

<style>
</style>
{#if show}
  {#if paymentOption === 'crypto'}
    <div class="frame mt-3 mx-4 pb-4">
      <CryptoPay {shop} done_handler={handle_crypto_payment_done}/>
    </div>
  {:else if paymentOption === 'fiat'}
    <div class="frame mt-12 mx-0 pb-4">
      <FiatPay {shop} {order} done_handler={handle_fiat_payment_done} paynow_handler={handle_paynow} done_paying_handler={handle_done_paying}/>
    </div>
  {/if}
{/if}
